/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum WorkPreferenceFilter {
  OpenToInclusionInMarketing = "OpenToInclusionInMarketing",
  OpenToMoreThanOneClient = "OpenToMoreThanOneClient",
  OpenToSecondments = "OpenToSecondments",
  OpenToPermanentPlacement = "OpenToPermanentPlacement",
  OpenToStructuredTeams = "OpenToStructuredTeams",
  OpenToCounsel = "OpenToCounsel",
  OpenToNotPerfectMatch = "OpenToNotPerfectMatch",
  OpenToLawFirms = "OpenToLawFirms",
  OpenToOnsite = "OpenToOnsite",
}

export const WorkPreferenceFilterDisplay: Record<WorkPreferenceFilter, string> = {
  [WorkPreferenceFilter.OpenToInclusionInMarketing]: "Open To Inclusion In Marketing",
  [WorkPreferenceFilter.OpenToMoreThanOneClient]: "Open To More Than One Client",
  [WorkPreferenceFilter.OpenToSecondments]: "Open To Secondments",
  [WorkPreferenceFilter.OpenToPermanentPlacement]: "Open To Permanent Placement",
  [WorkPreferenceFilter.OpenToStructuredTeams]: "Open To Structured Teams",
  [WorkPreferenceFilter.OpenToCounsel]: "Open To Counsel",
  [WorkPreferenceFilter.OpenToNotPerfectMatch]: "Open To Not Perfect Match",
  [WorkPreferenceFilter.OpenToLawFirms]: "Open To Law Firms",
  [WorkPreferenceFilter.OpenToOnsite]: "Open To Onsite",
};
